import { toast } from 'react-toastify';
import { default as _u } from 'underscore';

let registry = {};

/**
 * Generic function to show notification message via toast-er.
 *
 * @param level - 'warn', 'info' or any other available warning level
 * @param id - unique identifier of the message (for usage with debounce)
 * @param text - message to show
 */
const notify = (level, id, text) => {
    let fx;
    if (registry.hasOwnProperty(id)) {
        fx = registry[id];
        typeof fx === 'function' ? fx.cancel() : void 0;
    }
    fx = _u.debounce(toast[level].bind(toast, text), 1);
    registry[id] = fx;
    fx();
}

export function showInfo(id, text) {
    notify('info', id, text);
}

export function showWarning(id, text) {
    notify('warn', id, text);
}
